// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"1f91779a","287":"1acd0575","442":"9aafd9ed","479":"57347c2e","856":"e287175b","968":"f8c77475"}[chunkId] + ".chunk.js";
};